import React from 'react'
import { Button, Dropdown, DropdownButton, Form , InputGroup} from 'react-bootstrap'

function BasicInputGroups() {
  return (
    <>
    <Form.Group className='form-group'>
        <InputGroup>
                <div className='input-group-prepend'>
                    <InputGroup.Text>@</InputGroup.Text>
                </div>
                <Form.Control type='text' className='form-control' placeholder='Username' aria-describedby='basic-addon1' />
        </InputGroup>
    </Form.Group>
    <Form.Group className='form-group'>
    <InputGroup>
            <div className='input-group-prepend'>
                <InputGroup.Text className='bg-gradient-primary text-dark'>$</InputGroup.Text>
            </div>
            <Form.Control type='text' className='form-control' aria-label='Amount (to the nearest dollor)'/>
            <div className='input-group-append'>
                <InputGroup.Text>.00</InputGroup.Text>
            </div>
    </InputGroup>
    </Form.Group>
    <Form.Group className='form-group'>
    <InputGroup>
            <div className="input-group-prepend">
                <InputGroup.Text>$</InputGroup.Text>
            </div>
            <div className="input-group-prepend">
                
                <InputGroup.Text>0.00</InputGroup.Text>
            </div>
            <Form.Control type="text" className="form-control" aria-label="Amount (to the nearest dollar)" />
    </InputGroup>
    </Form.Group>
    <Form.Group className='form-group'>
    <InputGroup>
            <Form.Control type="text" className="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2" />
            <div className="input-group-append">
                <Button variant="btn btn-primary" size="sm">Search</Button>
            </div>
    </InputGroup>
    </Form.Group>
    <Form.Group className='form-group'>
    <InputGroup>
            <div className='input-group-prepend'>   
                <DropdownButton variant='btn btn-outline-primary' title="Dropdown" className='dropdown-toggle' size='sm'>
                    <Dropdown.Item className='dropdown-item' href="!#" onClick={event => event.preventDefault()}>Action</Dropdown.Item>
                    <Dropdown.Item className='dropdown-item' href="!#" onClick={event => event.preventDefault()}>Another action</Dropdown.Item>
                    <Dropdown.Item className='dropdown-item' href="!#" onClick={event => event.preventDefault()}>Something else</Dropdown.Item>
                    <div role='separator' className='dropdown-divider'></div>
                    <Dropdown.Item className='dropdown-item' href='!#' onClick={event => event.preventDefault()}>Seperated link</Dropdown.Item>
                </DropdownButton>
            </div>
            <Form.Control type="text" className="form-control" aria-label="Text input with dropdown button" />
    </InputGroup>
    </Form.Group>
    <Form.Group className='form-group'>
    <InputGroup>
            <Form.Control type='text' className='form-control' placeholder='Find in facebook' aria-label="Recipient's username" aria-describedby='basic-addon2'/>
            <div className='input-group-append'>
                <Button variant="btn btn-facebook" size="sm"><i className='fa-brands fa-facebook-f m-1'></i></Button>
            </div>
    </InputGroup>
    </Form.Group>
    </>

  )
}

export default BasicInputGroups